import { ReactNode } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { usePollingRate } from "../hooks";
import { TellescopeQueryProvider, useAuth } from "@tellescope/tanstack-query";
import { handleUserNotifications } from "../notifications";

export interface TellescopeQueryProviderWithPollingProps {
  children: ReactNode;
}

export const TellescopeTanstackQueryProvider = ({ children }: TellescopeQueryProviderWithPollingProps) => {
  const { session, currentUser, isAuthenticated } = useAuth();
  const queryClient = useQueryClient();
  const pollingRateInMs = usePollingRate();

  return (
    <TellescopeQueryProvider
      session={session}
      dataSyncPollingConfig={{
        responseSideEffect: async (_req, response) => {
          if (session) {
            await handleUserNotifications(response.results, currentUser, queryClient, session);
          }
        },
        pollingRateInMs,
        enabled: isAuthenticated,
      }}
      requestNotificationPermissionOnMount
      defaults={{
        autoCacheUpdateStrategy: "update",
        crossQueryCacheSharing: {
          models: ["users", "endusers"],
        },
        minSearchScore: 0.2,
      }}
    >
      {children}
    </TellescopeQueryProvider>
  );
};
